import { cn } from "@u/cn";

interface CountBadgeProps {
  count: number;
  /** Min digits, zero-padded. Default 3 → `[007]`. */
  pad?: number;
  className?: string;
}

/** Monospace bracketed counter, e.g. `[007]`. Shared across landing /
 *  portfolio headers (tour feed, directory tabs). */
export function CountBadge({ count, pad = 3, className }: CountBadgeProps) {
  return (
    <span className={cn("font-mono text-xs text-muted-foreground/80", className)}>
      [{count.toString().padStart(pad, "0")}]
    </span>
  );
}
